export function getRandomColor() {
    const randVal = () => (Math.floor(Math.random() * 256)).toString();
    return `rgba(${randVal()}, ${randVal()}, ${randVal()}, 1)`;
}